/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const logError = (object: any): void => {
  const environment = process.env.NODE_ENV || "development";
  if (environment === "development") {
    console.error(object);
  }
};
